gsap.registerPlugin(ScrollTrigger);
function horizontalLoop(items, config) {
	items = gsap.utils.toArray(items);
	config = config || {};
	let tl = gsap.timeline({
			repeat: config.repeat,
			paused: config.paused,
			defaults: { ease: "none" },
			onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
		}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		xPercents = [],
		curIndex = 0,
		pixelsPerSecond = (config.speed || 1) * 100,
		snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1),
		totalWidth,
		curX,
		distanceToStart,
		distanceToLoop,
		item,
		i;
	gsap.set(items, {
		xPercent: (i, el) => {
			let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
			xPercents[i] = snap(
				(parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
					gsap.getProperty(el, "xPercent")
			);
			return xPercents[i];
		},
	});
	gsap.set(items, { x: 0 });
	totalWidth =
		items[length - 1].offsetLeft +
		(xPercents[length - 1] / 100) * widths[length - 1] -
		startX +
		items[length - 1].offsetWidth *
			gsap.getProperty(items[length - 1], "scaleX") +
		(parseFloat(config.paddingRight) || 0);
	for (i = 0; i < length; i++) {
		item = items[i];
		curX = (xPercents[i] / 100) * widths[i];
		distanceToStart = item.offsetLeft + curX - startX;
		distanceToLoop =
			distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
		tl.to(
			item,
			{
				xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
				duration: distanceToLoop / pixelsPerSecond,
			},
			0
		)
			.fromTo(
				item,
				{
					xPercent: snap(
						((curX - distanceToLoop + totalWidth) / widths[i]) * 100
					),
				},
				{
					xPercent: xPercents[i],
					duration:
						(curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
					immediateRender: false,
				},
				distanceToLoop / pixelsPerSecond
			)
			.add("label" + i, distanceToStart / pixelsPerSecond);
		times[i] = distanceToStart / pixelsPerSecond;
	}
	function toIndex(index, vars) {
		vars = vars || {};
		Math.abs(index - curIndex) > length / 2 &&
			(index += index > curIndex ? -length : length); // always go in the shortest direction
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex];
		if (time > tl.time() !== index > curIndex) {
			// if we're wrapping the timeline's playhead, make the proper adjustments
			vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
			time += tl.duration() * (index > curIndex ? 1 : -1);
		}
		curIndex = newIndex;
		vars.overwrite = true;
		return tl.tweenTo(time, vars);
	}
	tl.next = (vars) => toIndex(curIndex + 1, vars);
	tl.previous = (vars) => toIndex(curIndex - 1, vars);
	tl.current = () => curIndex;
	tl.toIndex = (index, vars) => toIndex(index, vars);
	tl.times = times;
	tl.progress(1, true).progress(0, true); // pre-render for performance
	if (config.reversed) {
		tl.vars.onReverseComplete();
		tl.reverse();
	}
	return tl;
}
/////// START HERO HERE //////////////////////////////////////////////////////////////////////////////////////////////////////////
function app() {
	const slider = document.querySelector(".bdNewsSlider");
	const width = slider ? slider.offsetWidth : 0;
	const scrollMe = width - window.innerWidth;

	/*const tl = gsap.timeline({});

	const st = ScrollTrigger.create({
		trigger: ".newsSection",
		start: "top 12%",
		end: "+=" + scrollMe,
		pin: true,
		animation: tl,
		scrub: 1,
	});

	const boxes = gsap.utils.toArray(".bdNewsSlider li");
	boxes.forEach((box, i) => {
		var tv = i == 0 ? "<" : "";
		tl.to(box, {
			scale: 1,
			duration: 2,
		});
	});
	const tween = tl.fromTo(
		slider,
		{
			xPercent: 10,
		},
		{
			x: -scrollMe * 1.4,
			yPercent: 40,
			ease: "none",
			duration: 12,
		},
		0
	); */
	//ScrollTrigger.refresh();
  	
  
	let horizontal = gsap.utils.toArray(".bdFallingSlides aside ul li");
	let horizontalThumbMove = horizontal[0].clientWidth + 16;
	let articles = gsap.utils.toArray(".bdFallingSlides article");
	function getTotalHWidthToMove(ind) {
		return ind * horizontalThumbMove;
	}
	articles
		.slice(1)
		.forEach((art) => gsap.set(art, { xPercent: -100, opacity: 0 }));

	gsap.from(".bdFallingSlides", {
		scrollTrigger: {
			trigger: ".bdFallingSlides",
			start: "top 0",
			end: "+=" + getTotalHWidthToMove(horizontal.length - 1.5) * 1.7,
			pin: true,
			scrub: 1,
			invalidateOnRefresh: true,
		},
	});
	const timelines = [];

	horizontal.forEach((thumb, ind) => {
		if (!(ind == horizontal.length)) timelines.push(gsap.timeline({}));

		ScrollTrigger.create({
			trigger: ".bdFallingSlides",
			start: "top 0",
			scrub: 1,
			invalidateOnRefresh: true,
			end: () => "+=" + getTotalHWidthToMove(ind) * 1.7,
			animation: timelines[ind],
			onEnterBack: () => {
				gsap.to(articles[ind], {
					opacity: 1,
					xPercent: 0,
				});
				if (ind != articles.length)
					gsap.to(articles[ind + 1], {
						opacity: 0,
						xPercent: -100,
					});
			},
		});

		timelines[ind].to(thumb, {
			x: () => {
				return -getTotalHWidthToMove(ind);
			},
			scale: 0.85 + 0.02 * ind,
			rotateZ: -5 * (horizontal.length / 2 - 1) + 3 * ind + "deg",
			ease: "none",
			duration: 1.5 + ind * 1.5,
		});

		timelines[ind].to(
			"body",
			{
				onStart: () => {
					if (ind != horizontal.length - 1) {
						gsap.to(articles[ind], {
							opacity: 0,
							xPercent: -100,
						});
						gsap.to(articles[ind + 1], {
							opacity: 1,
							xPercent: 0,
						});
					}
				},
			},
			"+=" + (1 + 0.1 * ind)
		);
	});
	//Vertical
  /*
	let thumbNails = gsap.utils.toArray(".bdRows article");
	let thumbMove = thumbNails[0].clientHeight + 0;
	function getTotalWidthToMove(ind) {
		return ind * thumbMove;
	}

	const scrubValue = 1;
	gsap.from(".bdRows", {
		scrollTrigger: {
			trigger: ".bdRows",
			start: "top 15%",
			end: "+=" + getTotalWidthToMove(thumbNails.length - 0.5) * 1.5,
			pin: ".bdRowsHolder",
			scrub: scrubValue,
			invalidateOnRefresh: true,
		},
	});

	thumbNails.forEach((thumb, ind) => {
		gsap.fromTo(
			thumb,
			{
				scale: ind ? 1 + ind * 0.5 : 1,
				opacity: ind ? 0 : 1,
				filter: ind ? "blur(20px)" : "blur(0)",
			},
			{
				y: () => {
					return -getTotalWidthToMove(ind);
				},
				scale: 0.85 + 0.025 * ind,
				opacity: 0.95,
				filter: "blur(0px)",
				ease: "none",
				onComplete: () => {
					if (ind != thumbNails.length - 1)
						gsap.to(thumb, {
							opacity: 0,
							scale: 0.6,
							duration: 1,
							ease: "power4.out",
						});
				},
				scrollTrigger: {
					trigger: ".bdRows",
					start: "top -10%",
					scrub: scrubValue,
					invalidateOnRefresh: true,
					end: () => "+=" + getTotalWidthToMove(ind) * 1.5,
					onEnterBack: () => {
						if (ind >= 1)
							gsap.to(thumbNails[ind - 1], {
								scale: 0.85 + 0.025 * ind,
								opacity: 0.95,
								filter: "blur(0px)",
							});
					},
				},
			}
		);
	}); */
}
function entry() {
	gsap.set(".bdCtaImg > img", {
		"transform-origin": "bottom left",
	});
	gsap.from(".bdCtaImg > img", {
		xPercent: -100,
		opacity: 0,
		scale: 0.2,
		scrollTrigger: {
			trigger: ".bdCtaImg",

			start: "top 30%",
		},
	});
	gsap.from(".bdCtaImg .ctaContent > *", {
		ease: "Power2.easeInOut",
		y: "100px",
		opacity: 0,
		rotation: 5,
		duration: 0.6,
		stagger: 0.2,
		scrollTrigger: {
			trigger: ".bdCtaImg",

			start: "top 50%",
		},
	});
	gsap.from(".imageDropper li", {
		ease: "Power2.easeInOut",
		y: "-100%",
		rotation: -15,
		duration: 0.6,
		stagger: 0.2,
		scrollTrigger: {
			trigger: ".imageDropper",

			start: "top 50%",
		},
	});

	const comparisons = gsap.timeline({
		scrollTrigger: {
			trigger: ".bdCompare ul",
			scrub: true,
			start: "top 50%",
			end: "+=80%",
		},
	});
	gsap.utils.toArray(".bdCompare ul li").forEach((pImage) => {
		gsap.set(pImage, {
			opacity: 0,
			y: "100%",
		});
		comparisons.from(pImage, {
			duration: 0.5,
			onStart: () => {
				gsap.to(pImage, {
					y: 0,
					opacity: 1,
				});
			},
		});
	});

	gsap.from(
		".bdFeatureII article:nth-of-type(4n+3), .bdFeatureII article:nth-of-type(4n+3) + *",
		{
			ease: "elastic.out(1.2,0.75)",
			xPercent: 50,
			yPercent: 50,
			opacity: 0,
			duration: 1,
			stagger: 0.2,
			scrollTrigger: {
				trigger: ".bdFeatureII",

				start: "top 50%",
			},
		}
	);

	gsap.from(
		".bdFeatureII article:nth-of-type(4n+1), .bdFeatureII article:nth-of-type(4n+1) + *",
		{
			ease: "elastic.out(1.2,0.75)",
			xPercent: -50,
			yPercent: 50,
			opacity: 0,
			duration: 1,
			stagger: 0.2,
			scrollTrigger: {
				trigger: ".bdFeatureII",

				start: "top 50%",
			},
		}
	);
	gsap.from(".green .floatImage, .green .textContent > *", {
		ease: "Power2.easeInOut",
		y: "100px",
		scale: 0,
		opacity: 0,
		rotation: 5,
		duration: 0.6,
		stagger: 0.2,
		scrollTrigger: {
			trigger: ".green",

			start: "top 20%",
		},
	});
}
function initFires(id) {
	let c = init(id),
		w = window.innerWidth,
		h = window.innerHeight;
	//initiation

	class firefly {
		constructor() {
			this.x = Math.random() * w;
			this.y = Math.random() * h;
			this.s = Math.random() * 2;
			this.ang = Math.random() * 2 * Math.PI;
			this.v = (this.s * this.s) / 4;
		}
		move() {
			this.x += this.v * Math.cos(this.ang);
			this.y += this.v * Math.sin(this.ang);
			this.ang += (Math.random() * 20 * Math.PI) / 180 - (10 * Math.PI) / 180;
		}
		show() {
			c.beginPath();
			c.arc(this.x, this.y, 1.5 * this.s, 0, 12 * Math.PI);
			c.fillStyle = "#EECF00";
			c.fill();
		}
	}

	let f = [];

	function draw() {
		if (f.length < 150) {
			for (let j = 0; j < 10; j++) {
				f.push(new firefly());
			}
		}
		//animation
		for (let i = 0; i < f.length; i++) {
			f[i].move();
			f[i].show();
			if (f[i].x < 0 || f[i].x > w || f[i].y < 0 || f[i].y > h) {
				f.splice(i, 1);
			}
		}
	}

	function init(elemid) {
		let canvas = document.getElementById(elemid),
			c = canvas.getContext("2d"),
			w = (canvas.width = window.innerWidth),
			h = (canvas.height = window.innerHeight);
		c.fillStyle = "rgba(30,30,30,1)";
		c.fillRect(0, 0, w, h);
		return c;
	}

	window.requestAnimFrame = function () {
		return (
			window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function (callback) {
				window.setTimeout(callback);
			}
		);
	};

	var fireflies = document.getElementById(id);
	function loop() {
		if (ScrollTrigger.isInViewport(fireflies)) {
			window.requestAnimFrame(loop);
			c.clearRect(0, 0, w, h);
			draw();
		}
	}

	window.addEventListener("resize", function () {
		(w = canvas.width = window.innerWidth),
			(h = canvas.height = window.innerHeight);
		loop();
	});

	loop();
	setInterval(loop, 1000 / 60);
}

function mobile() {
	var tabsButton = document.querySelector(".mobileTabs");
	var tabsList = document.querySelector(".tabs");
	tabsButton.addEventListener("click", function (event) {
		event.stopPropagation();
		event.preventDefault();
		if (event.target === tabsButton) {
			console.log("triggered");
			tabsList.classList.add("open");
		}
	});
	if (document.querySelector(".slidesSwiper")) {
		const slideSwiper = new Swiper(".slidesSwiper", {
			// Optional parameters
			loop: false,
			slidesPerView: 1,

			navigation: {
				prevEl: ".slidesPrev",
				nextEl: ".slidesNext",
			},
		});
		var slides = document.querySelectorAll(".bdFallingSlides article");
		slides = [...slides];
		slideSwiper.on("slideChange", function () {
			//document.querySelector('.bdFallingSlides .active').classList.remove('active');
			slides[slideSwiper.previousIndex].classList.remove("active");
			slides[slideSwiper.realIndex].classList.add("active");
		});
	}
	if (document.querySelector(".featuresSwiper")) {
		const featuresSwiper = new Swiper(".featuresSwiper", {
			// Optional parameters
			loop: false,
			slidesPerView: "auto",
			spaceBetween: 30,
			navigation: {
				prevEl: ".featuredPrev",
				nextEl: ".featuredNext",
			},
		});
	}
}
////////// END HERO HERE ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
function createVerticalSlider(selector, direction, duration) {
	const setHeight = document.querySelector(selector).clientHeight + 18; //height of the boxes
	const numBoxes = document.querySelectorAll(selector).length; //quantity of boxes

	if (window.innerWidth < 960) mobile();
	//initially colorize each box and position in a row
	gsap.set(selector, {
		y: (i) => direction * i * setHeight,
	});
	// Gsap Time //
	const totalHeight = numBoxes * setHeight;
	const wrapOffsetTop = setHeight / -2;
	const wrapOffsetBottom = totalHeight + wrapOffsetTop;
	var wrap = gsap.utils.wrap(wrapOffsetTop, wrapOffsetBottom);
	const yheight = "+=" + totalHeight * -direction;
	// console.log("Num Boxes: " + numBoxes +". Total Box Height: " +totalHeight);

	tl = gsap.timeline();
	tl.to(selector, {
		duration: duration * numBoxes,
		ease: "none",
		y: yheight, //move each box the total height of all boxes to upwards
		modifiers: {
			y: gsap.utils.unitize(wrap), //force y value to wrap when it reaches -100
		},
		repeat: -1,
	});
}
function setImages() {
	const images = document.querySelectorAll("[data-src]");
	const imgOptions = {
		threshold: 0,
		rootMargin: "0px 2000px 800px 2000px",
	};
	const imgObserver = new IntersectionObserver((entries, imgObserver) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			} else {
				if (entry.target instanceof HTMLImageElement)
					preloadImage(entry.target);
				else {
					if ($(window).width() > 780) {
						preloadImage(entry.target);
					}
				}
				imgObserver.unobserve(entry.target);
			}
		});
	}, imgOptions);

	function preloadImage(img) {
		const src = img.getAttribute("data-src");
		if (!src) {
			return;
		}
		img.src = src;
	}
	images.forEach((image) => {
		imgObserver.observe(image);
	});
}
window.onload = () => {
  
	//Toggle menu mobile
	var mainMenu = document.querySelector('.shopify-section-group-header-group .mainMenu nav');
	document.querySelector('.openMobileMenu').addEventListener('click', (e)=>{
		mainMenu.classList.add('open');
	})
	document.querySelector('.closeMobileMenu').addEventListener('click', (e)=>{
		mainMenu.classList.remove('open');
	})
	if (document.querySelector(".newsSwiper")) {
		const swiper = new Swiper(".newsSwiper", {
			// Optional parameters
			loop: false,
			slidesPerView: 1,

			navigation: {
				prevEl: ".newsPrev",
				nextEl: ".newsNext",
			},
			breakpoints: {
				1080: {
				  slidesPerView: 2, // For screens larger than 1080px
				},
			  },
		});
	}

  	if (document.querySelector(".bdReviews")) {
      console.log("________________________________")
		const reviews = new Swiper(".bdReviews", {
			// Optional parameters
			loop: false,
			slidesPerView: 1,
			spaceBetween: 5,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				type: 'bullets',
			},
			breakpoints: {
				1080: {
				  slidesPerView: 3, // For screens larger than 1080px
				  spaceBetween: 32
				},
			  },
		});
	}
  
	var isnt_frontPage = document.querySelector(".notIndex");
	if (!isnt_frontPage && window.innerWidth > 960) {
		app();
		entry();
		initFires("canvas");
		const slideHolder = document.querySelector(".tiltSlideHolder");
		VanillaTilt.init(slideHolder, {
			perspective: 4000,
			max: 5,
		});
		const ctaImage = document.querySelector(".ctaImg");
		VanillaTilt.init(ctaImage);
	}

	// END HERO

	setImages();

	var vertSlider = document.querySelector(".verticalSlider");
	if (vertSlider) {
		createVerticalSlider(".rightVerticalSlide li", -1, 10);
		createVerticalSlider(".leftVerticalSlide li", 1, 10);
	}

	var tabs = document.querySelector(".bdTabs");
	if (tabs) {
		var currentTab = {
			button: tabs.querySelector(".buttonFull:not(.buttonLine)"),
			tab: tabs.querySelector(".tabContents .active"),
		};
		var tabButtons = tabs.querySelectorAll(".tabs button");
		[...tabButtons].forEach((tabButton) => {
			tabButton
				.querySelector("span")
				.style.setProperty("--mw", parseInt(tabButton.offsetWidth) + "px");
			tabButton.addEventListener("click", (e) => {
				if (tabButton.button == currentTab) return;
				else {
					currentTab.button.classList.add("buttonLine");
					currentTab.tab.classList.remove("active");

					tabButton.classList.remove("buttonLine");

					let el = document.getElementById(tabButton.dataset.target);
					el.classList.add("active");

					currentTab.button = tabButton;
					currentTab.tab = el;

					document.querySelector(".tabs").classList.remove("open");
					document.querySelector(".tabsActive").innerHTML =
						currentTab.button.innerHTML;
				}
			});
		});
	}

	var faqList = document.querySelectorAll(".faq ul li");
	if (faqList[0]) {
		faqList.forEach((fItem) => {
			fItem.style.setProperty(
				"--mh",
				parseInt(fItem.firstElementChild.lastElementChild.offsetHeight) +
					parseInt(fItem.firstElementChild.firstElementChild.offsetHeight) +
					"px"
			);
			fItem.style.setProperty(
				"--nh",
				fItem.firstElementChild.firstElementChild.offsetHeight + "px"
			);

			fItem.addEventListener("click", function (e) {
				e.preventDefault();
				let current = document.querySelector(".faq li.open");
				if (current) {
					if (current == fItem) fItem.classList.remove("open");
					else {
						current.classList.remove("open");
						fItem.classList.add("open");
					}
				} else {
					fItem.classList.add("open");
				}
			});
		});
		gsap.to(".faq", {
			scrollTrigger: {
				trigger: ".faq",
				start: "top 50%",
				onEnter: () => {
					let vid = document.querySelector(".faq video");
					vid.muted = true;
					vid.play();
				},
			},
		});
	}
	let holders = document.querySelector(".videoHolder");
	if (holders) {
		gsap.to(".videoHolder", {
			scrollTrigger: {
				trigger: ".videoHolder",
				start: "top 50%",
				onEnter: () => {
					let vid = document.querySelector(".videoHolder video");
					vid.muted = true;
					vid.play();
				},
			},
		});
	}
	if (document.querySelector(".legal")) {
		let st = ScrollTrigger.create({
			trigger: ".legal .stickme",
			pin: true,
			start: "top 0",
			end:
				"+=" +
				(document.querySelector(".legal").clientHeight - window.innerHeight),
		});
	}

	const logoLoop = gsap.utils.toArray(".logoSlider li");
	if (document.querySelector(".logoSlider")) {
		const logoSlider = horizontalLoop(logoLoop, {
			paused: true,
			repeat: -1,
			speed: 1,
		});

		logoSlider.play();
	}

	let svgns = "http://www.w3.org/2000/svg";
	let root = document.querySelector(".mousetrail");
	let ease = 0.75;

	let pointer = {
		x: window.innerWidth / 2,
		y: window.innerHeight / 2,
	};

	window.addEventListener("mousemove", (event) => {
		pointer.x = event.clientX;
		pointer.y = event.clientY;
	});

	let leader = (prop) => {
		return prop === "x" ? pointer.x : pointer.y;
	};

	let total = 100;
	for (let i = 0; i < total; i++) {
		leader = createLine(leader, i);
	}

	function createLine(leader, i) {
		let line = document.createElementNS(svgns, "line");
		root.appendChild(line);

		gsap.set(line, { x: -15, y: -15, opacity: (total - i) / total });

		let pos = gsap.getProperty(line);

		gsap.to(line, {
			duration: 1000,
			x: "+=1",
			y: "+=1",
			repeat: -1,
			ease: "none",
			modifiers: {
				x: () => {
					let posX = pos("x");
					let leaderX = leader("x");
					let x = posX + (leaderX - posX) * ease;
					line.setAttribute("x2", leaderX - x);
					return x;
				},
				y: () => {
					let posY = pos("y");
					let leaderY = leader("y");
					let y = posY + (leaderY - posY) * ease;
					line.setAttribute("y2", leaderY - y);
					return y;
				},
			},
		});

		return pos;
	}
	setTimeout(() => {
		gsap.to(root, {
			opacity: 1,
		});
	}, 1000);
	const hero = document.querySelector(".heroImages");
	VanillaTilt.init(hero, {
		perspective: 4000,
		max: 8,
	});
	const footer = document.querySelector(".footerInteractive");
	VanillaTilt.init(footer, {
		perspective: 5000,
	});

	initFires("footerCanvas");

	gsap.registerPlugin(ScrollToPlugin);
	var links = document.querySelectorAll('ul li a[href^="#"]');
	[...links].forEach((link) => {
		link.addEventListener("click", (e) => {
			e.preventDefault();
          	if (window.innerWidth < 960) {
				
				mainMenu.classList.remove("open");
			}
			gsap.to(window, {
				duration: 2,
				scrollTo: {
					y: link.getAttribute("href"),
					offsetY: 50,
					behavior: "smooth",
				},
				ease: "power2",
			});
		});
	});

	ScrollTrigger.create({
		start: "top -70",
		end: ScrollTrigger.maxScroll(window) + 1000,
		toggleClass: {
			className: "sticky",
			targets: ".shopify-section-group-header-group",
		},
	});

};
